// ダッシュボードの「今日やるべきこと」
// 対応ルーター: backend/routers/ugc_analytics.py の /ugc/analytics/next-actions

/**
 * クエリはパスに埋めない。任意項目を `{days}` のように書くと、未指定のときに
 * 置換されずそのまま送られて 422 になる（ファネルAPIで実際に起きた）。
 * 任意項目は vars に渡し、fetcher にクエリを組み立てさせる。
 */
export const UGCNextActionsApiPath = {
  GET_NEXT_ACTIONS: '/api/sites/{site_id}/ugc/analytics/next-actions'
} as const

export type NextActionSeverity = 'critical' | 'warning' | 'info'

export interface NextAction {
  /** 判定の識別子。表示の分岐に使う（画面側で網羅する必要はない） */
  key: string
  severity: NextActionSeverity
  title: string
  detail: string
  /** 遷移先のパス断片（例: ugc-reviews） */
  link: string
  /** 対象件数。件数の概念が無い判定は null */
  count: number | null
}

export interface GetNextActionsVars {
  site_id: number
  days?: number
}

/**
 * `actions` が空のとき、`all_clear` が true なら「判定して問題が無かった」。
 * 判定した観点の数は `checked` で分かるので、画面では「未判定」と区別して出せる。
 */
export interface NextActionsResponse {
  period_days: number
  checked: number
  all_clear: boolean
  actions: NextAction[]
}
